import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const Header = ({ headers, actionsButtons, selection, size }) =>
    <Box component={Paper} paddingX={2} paddingY={1}>
        <Grid container alignItems='center' spacing={1}>
            {selection && <Grid item size={0.5} />}
            {
                headers && headers.length > 0 &&
                headers.map((header, index) => {
                    let columnSize;
                    switch (header.value?.toLowerCase()) {
                        case 'master id':
                            columnSize = 1;
                            break;
                        case 'id':
                            columnSize = 1;
                            break;
                        case 'codigo de producto':
                            columnSize = 3;
                            break;
                        case 'color':
                            columnSize = 1;
                            break;
                        case 'descripcion':
                            columnSize = actionsButtons ? 3 : 4.5;
                            break;
                        case 'cantidad':
                            columnSize = 1;
                            break;
                        default:
                            columnSize = 2;
                    }

                    return (
                        <Grid key={index} item size={columnSize}>
                            <Typography variant="overline" component="p" align={header.align || 'left'}>
                                {header.value}
                            </Typography>
                        </Grid>
                    );
                })
            }
            {
                !!actionsButtons &&
                <Grid item size={1.5}>
                    <Box display='flex' justifyContent='flex-end'>
                        <Typography variant="overline">
                            Acciones
                        </Typography>
                    </Box>
                </Grid>
            }
        </Grid>
    </Box>

Header.defaultProps = {
    align: 'center'
}

Header.prototype = {
    headers: PropTypes.arrayOf(PropTypes.string),
    align: PropTypes.string,
    actionsButtons: PropTypes.number
}

export default Header;